import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export var TextPhraseExtractor = /*#__PURE__*/function () {
  function TextPhraseExtractor() {
    _classCallCheck(this, TextPhraseExtractor);
  }
  return _createClass(TextPhraseExtractor, null, [{
    key: "getTextPhrasesAroundCursor",
    value: function getTextPhrasesAroundCursor(state) {
      var selection = state.selection;
      if (!selection || selection.from !== selection.to) {
        return [];
      }
      var $from = selection.$from;
      var parent = $from.parent;
      var parentStart = $from.start($from.depth);
      var parentOffset = $from.parentOffset;
      var segments = this.extractPlainTextSegments(parent);
      var segment = this.findSegmentForCursor(segments, parentOffset);
      if (!segment) {
        return [];
      }
      var offsetInSegment = parentOffset - segment.from;
      var words = this.extractWordsFromSegment(segment);
      if (!words.length) {
        return [];
      }
      if (!this.isCursorTouchingWord(words, offsetInSegment)) {
        return [];
      }
      var centralWordIndex = this.findCentralWordIndex(words, offsetInSegment);
      var _this$extractNearbyWo = this.extractNearbyWords(words, centralWordIndex, parentStart, segment.from),
        nearbyWords = _this$extractNearbyWo.nearbyWords,
        centralWordPos = _this$extractNearbyWo.centralWordPos;
      return this.generateTextPhrases(nearbyWords, centralWordPos);
    }
  }, {
    key: "extractPlainTextSegments",
    value: function extractPlainTextSegments(parent) {
      var segments = [];
      var currentSegment = null;
      var flushSegment = function flushSegment() {
        if (currentSegment) {
          segments.push(currentSegment);
          currentSegment = null;
        }
      };
      var isPlainText = function isPlainText(child) {
        var _child$marks;
        return child.isText && !((_child$marks = child.marks) !== null && _child$marks !== void 0 && _child$marks.some(function (mark) {
          return mark.type.name === 'link';
        }));
      };
      parent.forEach(function (child, offset) {
        if (isPlainText(child)) {
          var text = child.text || '';
          if (currentSegment && offset === currentSegment.to) {
            currentSegment.text += text;
            currentSegment.to += text.length;
          } else {
            flushSegment();
            currentSegment = {
              text: text,
              from: offset,
              to: offset + text.length
            };
          }
        } else {
          flushSegment();
        }
      });
      flushSegment();
      return segments;
    }
  }, {
    key: "findSegmentForCursor",
    value: function findSegmentForCursor(segments, parentOffset) {
      return segments.find(function (seg) {
        return parentOffset >= seg.from && parentOffset <= seg.to;
      }) || null;
    }
  }, {
    key: "isCursorTouchingWord",
    value: function isCursorTouchingWord(words, relativeOffset) {
      return words.some(function (word) {
        return relativeOffset >= word.start && relativeOffset <= word.end;
      });
    }
  }, {
    key: "extractWordsFromSegment",
    value: function extractWordsFromSegment(segment) {
      var words = [];
      var _iterator = _createForOfIteratorHelper(segment.text.matchAll(this.WORD_REGEX)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var match = _step.value;
          words.push({
            text: match[0],
            start: match.index,
            end: match.index + match[0].length
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return words;
    }
  }, {
    key: "findCentralWordIndex",
    value: function findCentralWordIndex(words, cursorOffset) {
      if (words.length === 0) {
        return 0;
      }
      var lastIndex = words.length - 1;
      if (cursorOffset > words[lastIndex].end) {
        return lastIndex;
      }
      var idx = words.findIndex(function (w) {
        return w.start <= cursorOffset && w.end >= cursorOffset;
      });
      if (idx === -1) {
        idx = words.findIndex(function (w) {
          return w.end === cursorOffset;
        });
      }
      return idx === -1 ? lastIndex : idx;
    }
  }, {
    key: "extractNearbyWords",
    value: function extractNearbyWords(words, centralIndex, basePos, segmentFrom) {
      var adjustWord = function adjustWord(w) {
        return {
          word: w.text,
          from: basePos + segmentFrom + w.start,
          to: basePos + segmentFrom + w.end
        };
      };
      var startIndex = Math.max(0, centralIndex - this.WORDS_BEFORE_CENTRAL);
      var leftWords = words.slice(startIndex, centralIndex + 1).map(adjustWord);
      var rightWords = words.slice(centralIndex + 1, centralIndex + 1 + this.WORDS_AFTER_CENTRAL).map(adjustWord);
      return {
        nearbyWords: leftWords.concat(rightWords),
        centralWordPos: leftWords.length - 1
      };
    }
  }, {
    key: "generateTextPhrases",
    value: function generateTextPhrases(nearbyWords, centralIndex) {
      var phrases = [];
      for (var start = 0; start <= centralIndex; start++) {
        for (var end = centralIndex; end < nearbyWords.length; end++) {
          var phrase = nearbyWords.slice(start, end + 1).map(function (w) {
            return w.word;
          }).join(' ');
          phrases.push({
            phrase: phrase,
            from: nearbyWords[start].from,
            to: nearbyWords[end].to
          });
        }
      }
      return phrases;
    }
  }]);
}();
// Matches any non-whitespace character
_defineProperty(TextPhraseExtractor, "WORD_REGEX", /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/g);
_defineProperty(TextPhraseExtractor, "WORDS_BEFORE_CENTRAL", 4);
_defineProperty(TextPhraseExtractor, "WORDS_AFTER_CENTRAL", 2);
export var Cache = /*#__PURE__*/function () {
  function Cache() {
    var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    _classCallCheck(this, Cache);
    _defineProperty(this, "store", new Map());
    this.maxSize = maxSize;
    this.maxSize = maxSize;
  }
  return _createClass(Cache, [{
    key: "get",
    value: function get(key, compute) {
      if (this.store.has(key)) {
        var _value = this.store.get(key);
        if (_value) {
          return _value;
        }
      }
      var value = compute();
      if (value) {
        this.set(key, value);
      }
      return value;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      if (this.store.size >= this.maxSize) {
        var oldestKey = this.store.keys().next().value;
        if (oldestKey) {
          this.store.delete(oldestKey);
        }
      }
      this.store.set(key, value);
    }
  }]);
}();